import { showDialog } from '@bpinternal/ui-kit-next'
import { useRef } from 'react'
import { AddKnowledgeSourceContentProps } from '~/features/knowledge-bases/types'
import { AddKnowledgeSourceContent } from './AddKnowledgeSourceContent'
import { AddKnowledgeSourceStepContextProvider } from './AddKnowledgeSourceStepContext'

export const showAddKnowledgeSourceDialog = ({
  workspaceId,
  botId,
  kbId,
  dsId,
  startStep,
  hideBackArrow,
}: Omit<AddKnowledgeSourceContentProps, 'close'>) =>
  showDialog(
    ({ close }) => (
      <AddKnowledgeSourceDialog
        workspaceId={workspaceId}
        botId={botId}
        kbId={kbId}
        dsId={dsId}
        close={close}
        startStep={startStep}
        hideBackArrow={hideBackArrow}
      />
    ),
    { size: 'max-w-4xl', layout: 'custom', title: 'Add Knowledge Source' }
  )

export const AddKnowledgeSourceDialog = (props: AddKnowledgeSourceContentProps) => {
  const footerRef = useRef<HTMLDivElement>(null)

  return (
    <AddKnowledgeSourceStepContextProvider {...props} footerRef={footerRef}>
      <AddKnowledgeSourceContent {...props} />
      <div ref={footerRef} />
    </AddKnowledgeSourceStepContextProvider>
  )
}
